import { store } from '../../store';
import { upsertPatient } from '../../ReduxSlices/Patients/patientSlice';
import subscribeToCoreUpdates from '../core_updates_channel';

let unsubscribePatient = null; // store unsubscribe function

export function initializePatientSubscription() {
  if (unsubscribePatient) return; // already subscribed

  // Provide a unique module key "patient"
  unsubscribePatient = subscribeToCoreUpdates("patient", {
    "patient.updated": (data) => {
      //console.log("📡 patient.updated:", data);
      store.dispatch(upsertPatient(data));
    },
    "patient.created": (data) => {
      //console.log("📡 patient.created:", data);
      store.dispatch(upsertPatient(data));
    }
  });

  // console.log("✅ Patient subscription initialized");
}

export function unsubscribePatientSubscription() {
  if (unsubscribePatient) {
    unsubscribePatient(); // remove only Patient handlers
    unsubscribePatient = null;
   // console.log("🔌 Patient subscription removed");
  }
}